/**
 * Vue i18n
 *
 * @library
 *
 * http://kazupon.github.io/vue-i18n/en/
 */
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import getBrowserLocale, { supportedLocalesInclude } from './supported-locales'
Vue.use(VueI18n)

/**
 * Scans the ..src/i18n/locales directory for JSON files
 * and returns them as translation messages.
 * @return [{Object}]      Translation messages for each locale.
 */
function loadLocaleMessages () {
  const messages = {}
  const locales = require.context(
    './locales', // Directory to be scanned
    false, // Look inside folders
    /[A-Za-z0-9-_,\s]+\.json$/i // RegEx
  )

  locales.keys().forEach(dirName => {
    const matched = dirName.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1] // Group 1 - ([A-Za-z0-9-_]+)
      messages[locale] = locales(dirName)
    }
  })
  return messages
}

/**
 * Returns the default language/locale in the browser preference
 * Checks if the locale is supported, in both the "language variant" (eg. pt-BR) and the language code (eg. pt)
 * If not supported, returns english by default
 * @return {String}      Supported locale, either a default value ('en') or from browser preferences
 */
function getStartingLocale () {
  let browserLocale = getBrowserLocale({ countryCodeOnly: false })
  if (supportedLocalesInclude(browserLocale)) {
    return browserLocale
  }
  browserLocale = getBrowserLocale({ countryCodeOnly: true })
  if (supportedLocalesInclude(browserLocale)) {
    return browserLocale
  } else {
    return 'en'
  }
}

const i18n = new VueI18n({
  locale: getStartingLocale(),
  fallbackLocale: 'pt_BR',
  messages: loadLocaleMessages(),
  silentTranslationWarn: true // Removes the warnings from FALLBACK translations. TODO: Deal with this and remove the silentWarn.
})
export default i18n
